<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Wallet",
      text: "Customer",
      text1: "Wallet",
    };
  },
  methods: {
    submitForm() {
      this.$router.push("/customer/customer-wallet");
    },
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h4>Wallet</h4>
              <div>
                <a
                  href="javascript:void(0);"
                  class="btn btn-dark btn-sm d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add-wallet"
                  ><i class="ti ti-square-rounded-plus me-1"></i>Add Wallet</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col-lg col-md-3">
                <div class="card p-3">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <span
                        class="wallet-icon bg-gray rounded-circle d-flex align-items-center justify-content-center"
                        ><i class="ti ti-wallet"></i
                      ></span>
                    </div>
                    <div>
                      <span class="fs-13 text-gray text-truncate">Wallet Balance</span>
                      <h6 class="fs-18">$351.4</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-3">
                <div class="card p-3">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <span
                        class="wallet-icon bg-gray rounded-circle d-flex align-items-center justify-content-center"
                        ><i class="ti ti-wallet"></i
                      ></span>
                    </div>
                    <div>
                      <span class="fs-13 text-gray">Total Credit</span>
                      <h6 class="fs-18">$590.40</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-3">
                <div class="card p-3">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <span
                        class="wallet-icon bg-gray rounded-circle d-flex align-items-center justify-content-center"
                        ><i class="ti ti-wallet"></i
                      ></span>
                    </div>
                    <div>
                      <span class="fs-13 text-gray">Total Debit</span>
                      <h6 class="fs-18">$2,288.04</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-3">
                <div class="card p-3">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <span
                        class="wallet-icon bg-gray rounded-circle d-flex align-items-center justify-content-center"
                        ><i class="ti ti-wallet"></i
                      ></span>
                    </div>
                    <div>
                      <span class="fs-13 text-gray mb-0">Taxes</span>
                      <h6 class="fs-18">$351.4</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg col-md-3">
                <div class="card p-3">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <span
                        class="wallet-icon bg-gray rounded-circle d-flex align-items-center justify-content-center"
                        ><i class="ti ti-wallet"></i
                      ></span>
                    </div>
                    <div>
                      <span class="fs-13 text-gray mb-0">Savings</span>
                      <h5 class="fs-18">$200.00</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-4">
              <h6>Wallet Transactions</h6>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-resposnive">
                  <table class="table mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th>Type</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Payment Type</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><p class="fs-14">Wallet Topup</p></td>
                        <td>
                          <span class="text-success">+$80</span>
                        </td>
                        <td><p class="text-gray fs-14">07 Oct 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Purchase</p></td>
                        <td>
                          <span class="text-danger">-$20</span>
                        </td>
                        <td><p class="text-gray fs-14">06 Oct 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Refund</p></td>
                        <td>
                          <span class="text-success">+$40</span>
                        </td>
                        <td><p class="text-gray fs-14">06 Oct 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Wallet Topup</p></td>
                        <td>
                          <span class="text-success">+$100</span>
                        </td>
                        <td><p class="text-gray fs-14">28 Sep 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Purchase</p></td>
                        <td>
                          <span class="text-danger">-$50</span>
                        </td>
                        <td><p class="text-gray fs-14">07 Oct 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                      <tr>
                        <td><p class="fs-14">Refund</p></td>
                        <td>
                          <span class="text-danger">+$60</span>
                        </td>
                        <td><p class="text-gray fs-14">07 Oct 2022 11:22:51</p></td>
                        <td><p class="fs-14">Paypal</p></td>
                        <td>
                          <span class="badge badge-success-100">Completed</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <p>Show</p>
                <div class="dropdown mx-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle bg-light-600"
                    data-bs-toggle="dropdown"
                    >07</a
                  >
                  <ul class="dropdown-menu">
                    <li><a href="javascript:void(0);" class="dropdown-item">1</a></li>
                  </ul>
                </div>
                <p>entries</p>
              </div>
              <nav aria-label="Page navigation">
                <ul class="paginations d-flex justify-content-center align-items-center">
                  <li class="me-3">1 - 07 of 10</li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 active d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >1</a
                    >
                  </li>
                  <li class="page-item me-2">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >2</a
                    >
                  </li>
                  <li class="page-item">
                    <a
                      class="page-link-1 d-flex justify-content-center align-items-center"
                      href="javascript:void(0);"
                      >3</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
